<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="渠道">
					<c-select name="channel_code" clearable :options="channelOptions" placeholder="全部渠道"></c-select>
				</m-search-item>
				<m-search-item label="渠道场景">
					<c-select name="channel_scene" clearable :options="channelSceneOptions" placeholder="全部场景"></c-select>
				</m-search-item>
				<m-search-item label="背贴码">
					<c-input name="produce_unique_code" placeholder="请输入背贴码"></c-input>
				</m-search-item>
				<m-search-item label="背贴码查询维度">
					<c-select name="produce_code_match_field" clearable :options="produceCodeMatchOptions" placeholder="渠道商品ID"></c-select>
				</m-search-item>
				<m-search-item label="渠道订单号">
					<c-input name="biz_order_id"></c-input>
				</m-search-item>
				<m-search-item label="渠道商品ID">
					<c-input name="biz_product_id"></c-input>
				</m-search-item>
				<m-search-item label="ERP商品ID">
					<c-input name="product_id"></c-input>
				</m-search-item>
				<m-search-item label="接口名称">
					<c-input name="api_name" placeholder="支持模糊查询"></c-input>
				</m-search-item>
				<m-search-item label="调用类型">
					<c-select name="direction" clearable :options="directionOptions" placeholder="全部"></c-select>
				</m-search-item>
				<m-search-item label="调用结果">
					<c-select name="process_result" clearable :options="resultOptions" placeholder="全部"></c-select>
				</m-search-item>
				<m-search-item label="创建时间" colspan="2">
					<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
				</m-search-item>
			</m-search>

			<c-table ref="table" code="maintenance_api_call_log_list" height="grow">
				<c-table-column label="接口名称" name="api_name" width="160"></c-table-column>

				<c-table-column label="调用类型" name="direction" width="110">
					<template v-slot="{data}">
						<span>{{directionText(data.direction)}}</span>
					</template>
				</c-table-column>

				<c-table-column label="渠道" name="channel_code" width="100">
					<template v-slot="{data}">
						<span>{{platformMap[data.channel_code] || data.channel_code || '-'}}</span>
					</template>
				</c-table-column>
				<c-table-column label="渠道场景" name="channel_scene" width="180" ellipsis>
					<template v-slot="{data}">
						<span>{{channelSceneMap[data.channel_scene] || data.channel_scene || '-'}}</span>
					</template>
				</c-table-column>
                <c-table-column label="ERP商品ID" name="product_id" width="110"></c-table-column>
				<c-table-column label="渠道商品ID" name="biz_product_id" width="150" ellipsis></c-table-column>
				<c-table-column label="渠道订单号" name="biz_order_id" width="150" ellipsis></c-table-column>

				<c-table-column label="调用结果" name="process_result" width="90">
					<template v-slot="{data}">
						<span :style="{color: data.process_result == 2 ? '#e53e3e' : '#07b461'}">{{resultText(data.process_result)}}</span>
					</template>
				</c-table-column>

				<c-table-column label="处理耗时(ms)" name="cost_time" width="90"></c-table-column>
				<c-table-column label="创建时间" name="create_date" width="150"></c-table-column>

				<c-table-column type="button" label="操作" width="80" fixed="right">
					<template v-slot="{data}">
						<c-table-button icon="tf-detail" @click="$refs.detail.open(data.id)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>

			<api-call-log-detail ref="detail"></api-call-log-detail>
		</module>
	</page>
</template>

<script>
import ApiCallLogDetail from './api_call_log_detail.vue';

export default {
	name: 'p_maintenance_api_call_log_list',
	components: {ApiCallLogDetail},

	data() {
		return {
			channelOptions: [],
			channelSceneOptions: [],
			allSceneList: [],  // 全量场景列表（用于级联过滤）
			platformMap: {},  // 平台代码→平台名称映射（用于列表翻译）
			directionOptions: [
				{name: '中台→ERP', value: 1},
				{name: 'ERP→中台', value: 2}
			],
			resultOptions: [
				{name: '成功', value: 1},
				{name: '失败', value: 2}
			],
			produceCodeMatchOptions: [
				{name: '渠道商品ID', value: 'biz_product_id'},
				{name: 'ERP商品ID', value: 'product_id'},
				{name: '渠道订单ID', value: 'biz_order_id'}
			],
			channelSceneMap: {
				'CHX_DARK_AUCTION': '采货侠暗拍',
				'CHX_QUALITY_DEVICE': '采货侠靓机',
				'CHX_REVERSE_DARK_AUCTION': '采货侠反向暗拍',
				'CHX_REVERSE_QUALITY_DEVICE': '采货侠反向靓机',
				'GOOFISH_DARK_AUCTION': '闲鱼暗拍',
				'GOOFISH_QUALITY_DEVICE': '闲鱼靓机',
				'GOOFISH_STRICT_SELECTION': '闲鱼严选',
				'JD_DEFAULT': '京东严选',
				'TY_DEFAULT': '天翼商城',
				'ZZ_DEFAULT': '转转严选',
				'XIAOHEI_QUALITY_DEVICE': '小黑靓机',
				'XIAOHEI_DARK_AUCTION': '小黑暗拍'
			}
		}
	},

	mounted() {
		this.loadChannelOptions();
		this.$refs.search.search();
	},

	methods: {
		/*********渠道下拉（按平台去重，显示平台名称）**********/
		loadChannelOptions() {
			this.request({
				url: '/channel/list',
				data: {},
				success: data => {
					// 按 platform_code 去重，取 platform_name 作为显示名
					const platformMap = {};
					const allSceneList = [];  // 全量场景列表（用于级联过滤）
					(data || []).forEach(item => {
						// 渠道（平台）去重
						if (item.platform_code && !platformMap[item.platform_code]) {
							platformMap[item.platform_code] = item.platform_name || item.platform_code;
						}
						// 渠道场景（全量，带 platform_code 用于级联）
						if (item.channel_code) {
							allSceneList.push({
								name: item.channel_name || item.channel_code,
								value: item.channel_code,
								platform_code: item.platform_code
							});
						}
					});
					this.platformMap = platformMap;
					this.allSceneList = allSceneList;
					this.channelOptions = Object.entries(platformMap).map(([code, name]) => ({
						name: name,
						value: code
					}));
					this.channelSceneOptions = allSceneList;
				}
			});
		},

		/*********查询（渠道场景级联）**********/
		searchHandle(data) {
			// 渠道场景级联：根据选中的渠道过滤场景列表
			if (data.channel_code) {
				this.channelSceneOptions = this.allSceneList.filter(s => s.platform_code === data.channel_code);
			} else {
				this.channelSceneOptions = this.allSceneList;
			}
			this.$refs.table.load({
				url: '/maintenance/api-call-log/list',
				data
			});
		},

		/*********字典文案**********/
		directionText(v) {
			if (v == 1) return '中台→ERP';
			if (v == 2) return 'ERP→中台';
			return '-';
		},
		resultText(v) {
			if (v == 1) return '成功';
			if (v == 2) return '失败';
			return '-';
		}
	}
}
</script>
